const AppLayout = (resolve) =>
  require(['@/components/layout/AppLayout'], resolve);
const _import = (path, subPath) =>
  require('@/components/page/user/' +
    path +
    (subPath ? `/${subPath}/index` : '/index'));

const routes = {
  path: '/user',
  component: AppLayout,
  meta: {
    title: 'user',
    hidden: true
  },
  redirect: 'center',
  children: [
    {
      path: 'center',
      name: 'user-personal-center',
      meta: {
        title: 'user.personal-center',
        hidden: true,
      },
      component: _import('center')
    },
    {
      path: 'manual',
      name: 'user-manual',
      meta: {
        title: 'user.manual',
        hidden: true,
      },
      component: _import('manual')
    },
    {
      path: 'authorizelm',
      name: 'user-authorizelm',
      meta: {
        title: 'user.authorizelm',
        hidden: true,
      },
      component: _import('authorizelm')
    },
    {
      path: 'authorizelm/add',
      name: 'user-authorizelm-add',
      meta: {
        title: 'user.authorizelm.add',
        hidden: true,
      },
      component: _import('authorizelm','add')
    },
    {
      path: 'authorizedlevel',
      name: 'user-authorizedlevel',
      meta: {
        title: 'user.authorizedlevel',
        hidden: true,
      },
      component: _import('authorizedlevel')
    },
    {
      path: 'authorizedlevel/add',
      name: 'user-authorizedlevel-add',
      meta: {
        title: 'user.authorizedlevel.add',
        hidden: true,
      },
      component: _import('authorizedlevel','add')
    },
  ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/user.js